<template>
    <div class="container">
        <div class="header_bottom_box">
            <!-- logo -->
            <router-link :to="{path:'/main'}" class="header_bottom_logo">
                <img :src="$URL.baseUrl+'uploads/fast_logo.png'" alt="">
				<!-- <img src="../assets/img/footer/ltri8xJiqO.png" alt=""> -->
            </router-link>
            <!-- 中间导航栏部分 -->
            <div class="header_bottom_middle_box">
                <ul class="header_bottom_middle">
                    <li v-for="(item, index) in middle_nav"
                        :key="index">
                        <a href="javascript:;"
                            @click="handleNav(item, index)"
                            :class="{
                                active_bottom_nav: $route.params.priority == item.sort
                            }">
                            {{item.name}}
                        </a>
                    </li>
                </ul>
            </div>
            <!-- 搜索框 -->
            <div class="header_bottom_search_box">
                <el-autocomplete
                    class="header_bottom_search"
                    ref="headerSearch"
                    v-model="search"
                    :trigger-on-focus="false"
                    :highlight-first-item="false"
                    :fetch-suggestions="querySearch"
                    value-key='goods_name'
                    placement='bottom-start'
                    select-when-unmatched
                    :popper-append-to-body="false"
                    @select="handleSearch"
                    clearable
                    :placeholder="$t('message.header.placeholder')">
                    <el-button
                        slot="append"
                        @click="handleSearch">
                        <i class="el-icon-search search_icon"></i>
                    </el-button>
                </el-autocomplete>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
    data() {
        return {
            // 搜索框绑定参数
            search: "",
        }
    },
    computed: mapState({
        middle_nav: state => state.other.middle_nav,// 中间导航栏参数
        remote_search: state => state.other.remote_search,// 远程搜索框内容
    }),
    methods: {
        ...mapMutations([
            "setRemoteMethod"
        ]),
        ...mapActions([
            "getRemoteMethod",
        ]),
        handleNav(arg, index){
            this.$router.push({name: "plist",params: {priority:arg.sort}})
        },
        // 远程关键字同步
        querySearch(queryString, cb){
            this.getRemoteMethod(queryString).then(() => {
                cb(this.remote_search);
            })
        },
        // 关键字过滤
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.goods_name.toLowerCase().indexOf(queryString.toLowerCase()));
            };
        },
        // 搜索框搜索
        handleSearch(){
            let { id = "", brand = "", sort = "" } = this.$route.query;
            let { priority = "" } = this.$route.params;
            let query = {
                search:this.search
            };
            if(this.$route.name == "plist"){
                query.id = id;
                query.brand = brand;
                query.priority = priority;
                query.sort = sort;
            }
            this.$router.push({name:"plist",query})
                .then().catch((arg) => {
                    console.log("error:"+arg)
                });
            this.$refs.headerSearch.$refs.suggestions.showPopper = false;
        }
    },
    watch: {
        $route(to, from){
            if(to.name != 'plist'){ 
                this.search = "";
                this.setRemoteMethod([]);
            }
        }
    },
}
</script>

<style scoped>
/* 组件盒子 */
.header_bottom_box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;
}

/* logo */
.header_bottom_logo{
    width: 240px;
}
.header_bottom_logo>img{
    max-width: 100%;
    max-height: 100%;
}

/* 中间导航栏 */
.header_bottom_middle_box{
    flex-grow: 1;
    height: 100%;
}
.header_bottom_middle{
    height: 100%;
    overflow: hidden;
}
.header_bottom_middle>li{
    float: left;
    height: 100px;
    line-height: 100px;
    margin: 0 24px;
}
.header_bottom_middle>li>a{
    font-size: 16px;
    color: #333;
}
.header_bottom_middle>li>a.active_bottom_nav,
.header_bottom_middle>li>a:hover{
    color: #ff6700;
}

/* 搜索框 */
.header_bottom_search_box{
    width: 400px;
}
.header_bottom_search{
    width: 100%;
}
/* 
@media screen and (max-width: 1199px){
  .header_bottom_search_box{
    width: 300px;
  }
} */
</style>
